var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px / phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.49789 3.84277C8.86119 3.84277 9.19589 4.03978 9.37224 4.3574L10.5954 6.56081C10.7556 6.84931 10.7631 7.19826 10.6155 7.49341L9.43714 9.85026C9.43714 9.85026 9.77864 11.606 11.2078 13.0352C12.637 14.4644 14.3869 14.8 14.3869 14.8L16.7433 13.6218C17.0387 13.4741 17.3879 13.4817 17.6765 13.6422L19.8861 14.8707C20.2034 15.0471 20.4002 15.3816 20.4002 15.7447V18.2814C20.4002 19.5733 19.2003 20.5063 17.9762 20.0933C15.4623 19.245 11.5599 17.6299 9.08654 15.1565C6.61309 12.6831 4.998 8.78071 4.14973 6.26676C3.73672 5.04271 4.66976 3.84277 5.96159 3.84277H8.49789Z",
    fill: "#DA2128",
    stroke: "#DA2128",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ea126c5c7e4ecf3c8f0c4476cf439227.svg";
export { ForwardRef as ReactComponent };